import { computed, watch } from 'vue-demi';
import { getters as creativeGetters } from './../../store/modules/ads_creative/state';
import { InventoryFlow, CampaignObjectiveType } from '@ad/tt_ads_common_enums';
import { NO_LIMIT } from './../../const/fastCreation';
import ad from './../../store/modules/ads_creative/index';
import interestBehavior from '../../store/modules/smart-interests-and-behaviors';

const placement = computed(() => creativeGetters.audienceFormData.value.placement);
const interest = computed(() => creativeGetters.audienceFormData.value.interest);
const objectiveType = computed(() => ad.getters.campaignFormData.value.objectiveType);

// Reach和VideoView两种类型不显示smart interest选项
export const INVALID_OBJECTIVES = new Set([
  CampaignObjectiveType.ENGAGEMENT,
  CampaignObjectiveType.PRODUCT_SALES,
  CampaignObjectiveType.REACH,
  CampaignObjectiveType.VIDEOVIEW,
]);
export const IS_VALID_OBJECTIVE_TYPE = computed(() => !INVALID_OBJECTIVES.has(objectiveType.value));
export const IS_CORRECT_AD_PLACEMENT = computed(() => placement.value.includes(InventoryFlow.TIKTOK));
export const HAS_AT_LEAST_ONE_INTEREST_SELECTED = computed(
  () => !interest?.value?.value?.includes(NO_LIMIT.value),
);

const validUseCase = computed(
  (): boolean =>
    IS_VALID_OBJECTIVE_TYPE.value &&
    IS_CORRECT_AD_PLACEMENT.value &&
    HAS_AT_LEAST_ONE_INTEREST_SELECTED.value,
);

export const showSmartInterestToggle = computed(() => validUseCase.value);
showSmartInterestToggle.value && interestBehavior.mutations.showSmartInterest(true);
watch(showSmartInterestToggle, (newVal) => {
  interestBehavior.mutations.showSmartInterest(newVal);
  !newVal && interestBehavior.mutations.resetDefaultValues();
});
